// 액션 타입 정의
const POPUP_RESET = 'POPUP_RESET';
const PRICING_POPUP = 'PRICING_POPUP';

// 액션 생섬함수 정의
export const popupReset = () => ({ type: POPUP_RESET });
export const editPricingPopup = value => ({
  type: PRICING_POPUP,
  value
});

// 초기상태 정의
const initialState = {
  pricingPopup: {
    isShow: false
  }
};
// 리듀서 작성
export default function imageReducer(state = initialState, action) {
  switch (action.type) {
    case POPUP_RESET:
      return initialState;
    case PRICING_POPUP:
      return {
        ...state,
        pricingPopup: action.value
      };
    default:
      return state;
  }
}
